
// SearchFilter.js
import { TextField, useTheme, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";

const SearchFilter = ({
  searchValue,
  setSearchValue,
  data,
  setFilteredData,
  styling,
  loading,
  placeholder,
  isMobile = false,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearchInputChange = (e) => {
    const rawQuery = e.target.value;
    setSearchValue(rawQuery);
  };

  useEffect(() => {
    const filterData = () => {
      const query = searchValue.toLowerCase().trim();

      if (!query) {
        setFilteredData(data);
        return;
      }

      const filteredTrips = data?.filter((trip) => {
        try {
          const driverDetails = trip?.DriverDetails
            ? JSON.parse(trip.DriverDetails)
            : {};
          const vehicleDetails = trip?.VehicleDetails
            ? JSON.parse(trip.VehicleDetails)
            : {};
          const corporateDetails = trip?.CorporateDetails
            ? JSON.parse(trip.CorporateDetails)
            : {};

          const taskDetails = trip?.taskDetails
            ? JSON.parse(trip.taskDetails)
            : [];
          const parsedTaskDetails = Array.isArray(taskDetails)
            ? taskDetails
            : [];

          const pumpName =
            parsedTaskDetails.find((f) => f.FieldID === "PUMP_NAME")?.Answer ||
            "";
          const fuelType =
            parsedTaskDetails.find((f) => f.FieldID === "FUEL_TYPE")?.Answer ||
            "";
          const paymentType =
            parsedTaskDetails.find((f) => f.FieldID === "PAYMENT_TYPE")
              ?.Answer || "";

          const hasMatchingCorporate = trip.corporates?.some((corporate) =>
            String(corporate.name || "")
              .toLowerCase()
              .includes(query)
          );

          return (
            String(driverDetails.DriverName || "")
              .toLowerCase()
              .includes(query) ||
            String(driverDetails.emailID || "")
              .toLowerCase()
              .includes(query) ||
            String(vehicleDetails.regNumber || "")
              .toLowerCase()
              .includes(query) ||
            String(vehicleDetails.model || "")
              .toLowerCase()
              .includes(query) ||
            String(corporateDetails.name || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.driverName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.DriverTripID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.name || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.corporateID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.status || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.corporateName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.DepartmentName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.DepartmentID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.parentID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.Name || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.TaskName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.CarModel || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.ID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.CarNumber || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.emailID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.fName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.vehicleNumber || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.regNumber || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.color || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.maker || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.model || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.vehicleType || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.fuelType || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.bookingID || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.DriverName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.RouteName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.partnerName || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.driver_name || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.car_info || "")
              .toLowerCase()
              .includes(query) ||
            String(trip.shift_id || "")
              .toLowerCase()
              .includes(query) ||
            String(pumpName || "")
              .toLowerCase()
              .includes(query) ||
            String(fuelType || "")
              .toLowerCase()
              .includes(query) ||
            String(paymentType || "")
              .toLowerCase()
              .includes(query) ||
            hasMatchingCorporate
          );
        } catch (e) {
          console.error("Error parsing JSON fields:", e);
          return false;
        }
      });
      setFilteredData(filteredTrips);
    };

    filterData();
  }, [searchValue, data, setFilteredData]);

  return (
    <TextField
      label="Search"
      type="text"
      value={searchValue}
      onChange={handleSearchInputChange}
      placeholder={
        (localStorage.getItem("roleId") === "1" && placeholder) || "Search"
      }
      className="route-search-input"
      size={isSmallScreen ? "small" : "medium"}
      variant="standard"
      disabled={loading}
      sx={{
        width: isSmallScreen ? "100%" : "auto",
        ...styling,
      }}
      fullWidth={isSmallScreen}
    />
  );
};

export default SearchFilter;
